import {
  ICombinedSimpleModel,
  ISimpleFilterModel,
} from '@ag-grid-community/core'
import { ProvidedFilterModel } from '@ag-grid-community/core/dist/cjs/interfaces/iFilter'
import {
  convertICombinedSimpleModelToDateFilter,
  convertISimpleFilterModelToDateFilter,
} from './filters/date-filter'
import { Filter } from './filters/filter'
import {
  convertICombinedSimpleModelToNumberFilter,
  convertISimpleFilterModelToNumberFilter,
} from './filters/number-filter'
import { convertISimpleFilterModelToSetFilter } from './filters/set-filter'
import {
  convertICombinedSimpleModelToTextFilter,
  convertISimpleFilterModelToTextFilter,
} from './filters/text-filter'
import {
  convertICombinedSimpleModelToTimeFilter,
  convertISimpleFilterModelToTimeFilter,
} from './filters/time-filter'

/**
 *
 */
function convertCombinedFilter(
  filter: ICombinedSimpleModel<ISimpleFilterModel>,
) {
  switch (filter.condition1.filterType) {
    case 'date':
    case 'datetime':
      return convertICombinedSimpleModelToDateFilter(filter)
    case 'number':
      return convertICombinedSimpleModelToNumberFilter(filter)
    case 'text':
      return convertICombinedSimpleModelToTextFilter(filter)
    case 'time':
      return convertICombinedSimpleModelToTimeFilter(filter)
    default:
      console.error('Filter not supported', filter)
      return null
  }
}

/**
 *
 */
function convertSimpleFilter(filter: ISimpleFilterModel): Filter | null {
  switch (filter.filterType) {
    case 'set':
      return convertISimpleFilterModelToSetFilter(filter)
    case 'date':
    case 'datetime':
      return convertISimpleFilterModelToDateFilter(filter)
    case 'number':
      return convertISimpleFilterModelToNumberFilter(filter)
    case 'text':
      return convertISimpleFilterModelToTextFilter(filter)
    case 'time':
      return convertISimpleFilterModelToTimeFilter(filter)
    default:
      console.error('Filter not supported', filter)
      return null
  }
}

/**
 * Decides to use a simple or combined filter
 */
function convertFilter(filter: ProvidedFilterModel): Filter | null {
  if ((filter as ICombinedSimpleModel<ISimpleFilterModel>).operator != null) {
    return convertCombinedFilter(
      filter as ICombinedSimpleModel<ISimpleFilterModel>,
    )
  } else {
    return convertSimpleFilter(filter as ISimpleFilterModel)
  }
}

/**
 * For some reason, ag-grid sends a filter model as an any type.
 */
export type FilterModel<T> = Partial<{ [key in keyof T]: ProvidedFilterModel }>

/** Convert ag-grid filterModel into Helios backend filterModel */
export function convertFilters<T>(filterModel: FilterModel<T>) {
  return Object.entries<ProvidedFilterModel>(
    filterModel as Record<string, ProvidedFilterModel>,
  ).reduce((prevValue, [key, filter]) => {
    const conversion = convertFilter(filter)
    if (conversion == null) {
      return prevValue
    }
    return {
      ...prevValue,
      [key]: conversion,
    }
  }, {}) as { [key in keyof T]: Filter }
}
